import fp from 'lodash/fp';

export const getMonitoringRows = fp.get('staticDataGeneral.rows');

export const getLoadingStatus = fp.get('staticDataGeneral.loading');
